import { patch } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface ReturnOrderParams {
    orders: string[];
}

export interface RetunOrderSelectModel extends BaseModel {
    uri: any;
    returnCode: string;
    returnMessage: any;
    reasonCodes: ReasonCode[];
    orders: Order[];
    contact: Contact;
    properties: any;
}

export interface ReasonCode {
    code: string;
    description: string;
}

export interface Order {
    orderNumber: string;
    orderHasReturnableItems: boolean;
    products: Product[];
    poSyntax: string;// added ---P21 Change
}

export interface Product {
    orderHasReturnableItems: boolean;
    item: string;
    bimocs: string;
    description: string;
    priceExtended: number;
    itemInd: string;
    dgInd: string;
    adonisDate: string;
    adonisSeq: string;
    qty: number;
    sequence: number;
    price: number;
    orderNumber: string;
    returnsCompleted: number;
    custOptions: CustOption[];
    canBeReturned: boolean;
    returnsInProgress: number;
    returnMinReq: number;
    serialNumberRequired: string[];
    techRARequired: string[];
    type: string[];
    shipUnitNumber: string;
    productDto: ProductDto;
}

export interface CustOption {
    type: string;
    options: any[];
}

export interface ProductDto {
    id: string;
    orderLineId: any;
    name: string;
    customerName: any;
    shortDescription: string;
    erpNumber: string;
    erpDescription: string;
    urlSegment: string;
    basicListPrice: number;
    basicSalePrice: number;
    basicSaleStartDate: string;
    basicSaleEndDate: string;
    smallImagePath: string;
    mediumImagePath: string;
    largeImagePath: string;
    pricing: Pricing;
    currencySymbol: string;
    qtyOnHand: number;
    isConfigured: boolean;
    isFixedConfiguration: boolean;
    isActive: boolean;
    isHazardousGood: boolean;
    isDiscontinued: boolean;
    isSpecialOrder: boolean;
    isGiftCard: boolean;
    isBeingCompared: boolean;
    isSponsored: boolean;
    isSubscription: boolean;
    quoteRequired: boolean;
    manufacturerItem: string;
    packDescription: string;
    altText: string;
    customerUnitOfMeasure: any;
    canBackOrder: boolean;
    trackInventory: boolean;
    multipleSaleQty: number;
    minimumOrderQty: number;
    htmlContent: any;
    productCode: string;
    priceCode: string;
    sku: string;
    upcCode: string;
    modelNumber: string;
    taxCode1: string;
    taxCode2: string;
    taxCategory: any;
    shippingClassification: string;
    shippingLength: string;
    shippingWidth: string;
    shippingHeight: string;
    shippingWeight: string;
    qtyPerShippingPackage: number;
    shippingAmountOverride: any;
    handlingAmountOverride: any;
    metaDescription: string;
    metaKeywords: string;
    pageTitle: string;
    allowAnyGiftCardAmount: boolean;
    sortOrder: number;
    hasMsds: boolean;
    unspsc: string;
    roundingRule: string;
    vendorNumber: string;
    configurationDto: any;
    unitOfMeasure: string;
    unitOfMeasureDisplay: string;
    unitOfMeasureDescription: string;
    selectedUnitOfMeasure: string;
    selectedUnitOfMeasureDisplay: string;
    productDetailUrl: string;
    canAddToCart: boolean;
    allowedAddToCart: boolean;
    canAddToWishlist: boolean;
    canViewDetails: boolean;
    canShowPrice: boolean;
    canShowUnitOfMeasure: boolean;
    canEnterQuantity: boolean;
    canConfigure: boolean;
    isStyleProductParent: boolean;
    styleParentId: any;
    requiresRealTimeInventory: boolean;
    numberInCart: number;
    qtyOrdered: number;
    availability: Availability;
    styleTraits: any[];
    styledProducts: any[];
    attributeTypes: any[];
    documents: any[];
    specifications: any[];
    crossSells: any[];
    accessories: any[];
    productUnitOfMeasures: ProductUnitOfMeasure[];
    productImages: ProductImage[];
    properties: Properties;
    score: number;
    searchBoost: number;
    searchBoostDecimal: number;
    salePriceLabel: any;
    cantBuy: boolean;
    allowZeroPricing: boolean;
    brand: any;
    productLine: any;
    productSubscription: ProductSubscription;
    replacementProductId: any;
    warehouses: any[];
    relatedProducts: any[];
    alsoPurchasedProducts: any[];
}

export interface Pricing {
    isOnSale: boolean;
    requiresRealTimePrice: boolean;
    additionalResults: AdditionalResults;
    unitCost: number;
    unitCostDisplay: any;
    unitListPrice: number;
    unitListPriceDisplay: string;
    extendedUnitListPrice: number;
    extendedUnitListPriceDisplay: string;
    unitRegularPrice: number;
    unitRegularPriceDisplay: string;
    extendedUnitRegularPrice: number;
    extendedUnitRegularPriceDisplay: string;
    unitNetPrice: number;
    unitNetPriceDisplay: string;
    extendedUnitNetPrice: number;
    extendedUnitNetPriceDisplay: string;
    unitOfMeasure: any;
    vatRate: number;
    vatAmount: number;
    vatAmountDisplay: any;
    unitListBreakPrices: any;
    unitRegularBreakPrices: any;
    regularPrice: number;
    regularPriceDisplay: string;
    extendedRegularPrice: number;
    extendedRegularPriceDisplay: string;
    actualPrice: number;
    actualPriceDisplay: string;
    extendedActualPrice: number;
    extendedActualPriceDisplay: string;
    regularBreakPrices: any;
    actualBreakPrices: any;
    unitListPriceWithVat: number;
    unitListPriceWithVatDisplay: any;
    extendedUnitListPriceWithVat: number;
    extendedUnitListPriceWithVatDisplay: any;
    unitRegularPriceWithVat: number;
    unitRegularPriceWithVatDisplay: any;
    extendedUnitRegularPriceWithVat: number;
    extendedUnitRegularPriceWithVatDisplay: any;
    vatMinusExtendedUnitRegularPrice: number;
}

export interface AdditionalResults {
    inventoryMessageCode: string;
    localInventory: string;
    isVisible: string;
    salesIndicator: string;
}

export interface Availability {
    messageType: number;
    message: string;
    requiresRealTimeInventory: boolean;
}

export interface ProductUnitOfMeasure {
    productUnitOfMeasureId: string;
    unitOfMeasure: string;
    unitOfMeasureDisplay: string;
    description: string;
    qtyPerBaseUnitOfMeasure: number;
    roundingRule: string;
    isDefault: boolean;
    availability: Availability2;
}

export interface Availability2 {
    messageType: number;
    message: any;
    requiresRealTimeInventory: boolean;
}

export interface ProductImage {
    id: string;
    sortOrder: number;
    name: string;
    imageType: string;
    smallImagePath: string;
    mediumImagePath: string;
    largeImagePath: string;
    altText: string;
}

export interface Properties {
    productcategoryno: string;
    productcategoryid: string;
    adI_ExclusiveBrands: string;
    productcategory: string;
    productcategoryurl: string;
    defaultVisibility: string;
    bestseller: string;
    branD_ID: string;
    branD_SHORTDESC: string;
    classificatioN_CODE: string;
    countrY_OF_ORIGIN: string;
    featureBullets1to10: string;
    featureBullets1to3: string;
    iskit: string;
    iteM_WEIGHT: string;
    itemstatus: string;
    jsonSpecs: string;
    minimuM_QTY: string;
    mkt_Info: string;
    musT_SHP_LTL: string;
    ndaaCompliant: string;
    vendor_ID: string;
    branD_SEGMENT: string;
    branD_PATH: string;
    abcCode: string;
    showAuthorizationRequired: string;
    salesIndicator: string;
    inventoryMessageCode: string;
    onsalenow?: string;
    thumbnail1Url?: string;
    thumbnail2Url?: string;
    video1Url?: string;
}

export interface ProductSubscription {
    subscriptionAddToInitialOrder: boolean;
    subscriptionAllMonths: boolean;
    subscriptionApril: boolean;
    subscriptionAugust: boolean;
    subscriptionCyclePeriod: string;
    subscriptionDecember: boolean;
    subscriptionFebruary: boolean;
    subscriptionFixedPrice: boolean;
    subscriptionJanuary: boolean;
    subscriptionJuly: boolean;
    subscriptionJune: boolean;
    subscriptionMarch: boolean;
    subscriptionMay: boolean;
    subscriptionNovember: boolean;
    subscriptionOctober: boolean;
    subscriptionPeriodsPerCycle: number;
    subscriptionSeptember: boolean;
    subscriptionShipViaId: any;
    subscriptionTotalCycles: number;
}

export interface Contact {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

const url = "/api/v1/returns/submit";
const urlGetOrders = "/api/v1/returns/getOrders";

export function getReturnOrders(parameter: ReturnOrderParams) {
    return patch<RetunOrderSelectModel>(`${urlGetOrders}`, parameter as any);
}

export function returnProducts(parameter: any) {
    return patch<any>(`${url}`, parameter.payloadResponse  as any);
}
